import type { TypeFormFieldElement } from '../../../types/form';

import isFormFieldElement from './isFormFieldElement';

// ----------------------------------------------------------------------------

function getVisibleFieldForHidden(field: TypeFormFieldElement): TypeFormFieldElement | null {
    if (!(field instanceof HTMLInputElement) || field.type !== 'hidden') {
        return null;
    }

    return isFormFieldElement(field.nextElementSibling) ? field.nextElementSibling : null;
}

// ----------------------------------------------------------------------------

export default getVisibleFieldForHidden;
